import { BehaviorSubject, Observable, of } from 'rxjs';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';
import { Prevision } from '../models/prevision.entity';
import { PrevisionsService } from '../services/previsions.service';

/**
 * Movements data source
 */
export class PrevisionDataSource implements DataSource<Prevision> {
  /**
   * Previsions subject
   *
   * @private
   */
  private previsionSubject = new BehaviorSubject<Prevision[]>([]);

  /**
   * Loading subject
   *
   * @private
   */
  private loadingSubject = new BehaviorSubject<boolean>(false);

  /**
   * Loading observable
   *
   */
  public loading$ = this.loadingSubject.asObservable();

  /**
   * Constructor
   *
   * @param previsionService Previsions service
   */
  constructor(private previsionService: PrevisionsService) {}

  /**
   * Connect to collection
   *
   * @param collectionViewer CollectionViewer
   *
   * @returns Observable
   */
  connect(collectionViewer: CollectionViewer): Observable<Prevision[]> {
    return this.previsionSubject.asObservable();
  }

  /**
   * Disconnect from collection
   *
   * @param collectionViewer CollectionViewer
   */
  disconnect(collectionViewer: CollectionViewer): void {
    this.previsionSubject.complete();
    this.loadingSubject.complete();
  }

  /**
   * Load data from collection
   *
   * @param order Order
   * @param sort Sort
   * @param limit Limit
   * @param page Page
   * @param filter Object with filtered attributes
   */

  load(
    order: string = 'STTRG',
    sort: string = 'asc',
    limit: number = 30,
    page: number = 0,
    filter: object = {
      today: true,
    }
  ): void {
    this.loadingSubject.next(true);

    if (order === 'SAMCA_STATUS') {
      order = 'STTRG';
    }

    const options = { order, sort, limit, page };

    for (const i in filter) {
      if (filter.hasOwnProperty(i) && filter[i] === '') {
        delete filter[i];
      }
    }
    // console.log('ha pasado por load');
    this.previsionService
      .findFiltered({ ...options, ...filter })
      .pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(previsions => {
        this.previsionSubject.next(previsions);
      });
  }
}
